import axios from "axios"
import { toast } from "react-toastify"

const fetchHomeCreateNewsDataRequest = () => {
	return {type: "FETCH_HOMEPAGE_CREATE_NEWS_REQUEST"}
}

const fetchHomeCreateNewsDataSuccess = (create_news) => {
	return {type: "FETCH_HOMEPAGE_CREATE_NEWS_SUCCESS", payload: create_news}
}

const fetchHomeCreateNewsDataFailure = (error) => {
	return {type: "FETCH_HOMEPAGE_CREATE_NEWS_FAILURE", payload: error}
}

export const fetchCreateNews = (data) => {
	return (dispatch) => {
		dispatch(fetchHomeCreateNewsDataRequest())
		axios.post("admin/news", data)
		.then(response => {
			const create_news = response.data
			dispatch(fetchHomeCreateNewsDataSuccess(create_news))	
			toast.dismiss()	
			toast.success("با موفقیت ایجاد شد" , {position: 'bottom-right',className: 'foo-bar'})
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchHomeCreateNewsDataFailure(error))	
			toast.dismiss()
			toast.error("مشکلی پیش آمده است" , {position: 'bottom-right',className: 'foo-bar'})
		})
	}
}